'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsProductOwned = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _getProducts = require('self-service-api/api/getProducts');

var _getProducts2 = _interopRequireDefault(_getProducts);

var _getParcels = require('self-service-api/api/getParcels');

var _getParcels2 = _interopRequireDefault(_getParcels);

var _validators = require('self-service-api/core/validators');

var _isProductOwnedAdapter = require('self-service-api/adapters/isProductOwnedAdapter');

var _isProductOwnedAdapter2 = _interopRequireDefault(_isProductOwnedAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIsProductOwned = exports.getIsProductOwned = function getIsProductOwned(merchandiseId) {
  (0, _validators.validateMerchandiseId)(merchandiseId);

  return _q2.default.Promise.all([(0, _getProducts2.default)(), (0, _getParcels2.default)()]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        products = _ref2[0],
        parcels = _ref2[1];

    return (0, _isProductOwnedAdapter2.default)(products, parcels, merchandiseId);
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/api/getIsProductOwned.js
// module id = 287
// module chunks = 3 4 5